/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/*
===============
Custom Scripts
===============
*/

$(document).ready(function() {

    /*
    =============
    Calculate VH
    =============
    */
    
    function calculate_vh() {
        // First we get the viewport height and we multiple it by 1% to get a value for a vh unit...
        var vh = window.innerHeight * 0.01;
        // Then we set the value in the --vh custom property to the root of the document...
        document.documentElement.style.setProperty('--vh', vh + 'px');
    }
    calculate_vh();
    window.addEventListener('resize', calculate_vh, { passive: true });
    window.addEventListener('orientationchange', calculate_vh, { passive: true });

    /*
    =============
    Gift Message
    =============
    */

    // Check gift message character count...
    $(document).on('keyup', 'input#gift-message-to, textarea#gift-message-text', function() {
        var gift_message_to = $('input#gift-message-to').val();  
        var to_character_count = gift_message_to.length;
        var gift_message_text = $('textarea#gift-message-text').val();
        var text_character_count = gift_message_text.length;
        var character_count = (to_character_count + text_character_count);
        $('div#gift-message-counter span.current').text(character_count);
        if ( character_count > 150 ) {
            $('div#gift-message-counter').addClass('error');
            $('button#save-cart-note').attr('disabled', true);
        } else {
            $('div#gift-message-counter').removeClass('error');
            $('button#save-cart-note').attr('disabled', false);
        }
    });

    // Save gift message...
    $(document).on('click', 'button#save-cart-note', function() {
        var gift_message_to = $('input#gift-message-to').val();  
        var gift_message_text = $('textarea#gift-message-text').val();
        if ( gift_message_to !== '' || gift_message_text !== '' ) {
            var final_gift_message = gift_message_to + ' | ' + gift_message_text;
            $('button#cart-note-btn').text('Edit Gift Message');
        } else {
            var final_gift_message = '';
            $('button#cart-note-btn').text('Add Gift Message');
        }
        $('textarea#cart-note').val(final_gift_message);
        $.ajax({
            url: '/cart/update',
            dataType: 'json',
            method : 'POST',
            data: {
                note: final_gift_message,
            }
        });
    });

    // Open gift message popup...
    $(document).on('click', 'a#gift-message-popup-btn', function(e) {
        e.preventDefault();
        $('div#gift-message-popup').addClass('active');
    });

    // Close gift message popup...
    $(document).on('click', 'a#close-gift-message-popup', function(e) {
        e.preventDefault();
        $('div#gift-message-popup').removeClass('active');
    });

    // Gift message example slider...
    $('div.gift-message-slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        speed: 600,
        fade: false,
        autoplay: true,
        autoplaySpeed: 6000,
        pauseOnHover: true
    });
  
});